import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DualIcon,
  FormFieldSet,
  LogoLoader,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { fetchFollowupInterviewsStart } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllNotes,
  updateSubmissionStatus,
  addVisitHistoryApi,
  fetchVisitHistorysApi,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
//import InterviewFollowup from "../../Applicants/Applicant/InterviewFollowup";

const statusOptions = [
  { label: "Shortlisted for Interview", value: 12 },
  { label: "Interview Confirmation", value: 13 },
  { label: "Interview Scheduled", value: 14 },
  { label: "L1 Interview Scheduled", value: 15 },
  { label: "L2 Interview Scheduled", value: 16 },
  { label: "L3 Interview Scheduled", value: 17 },
  { label: "L1 Interview Selected", value: 18 },
  { label: "L2 Interview Selected", value: 19 },
  { label: "L3 Interview Selected", value: 20 },
  { label: "L1 Interview Rejected", value: 21 },
  { label: "L2 Interview Rejected", value: 22 },
  { label: "L3 Interview Rejected", value: 23 },
  { label: "L1 Interview Re-Scheduled", value: 24 },
  { label: "L2 Interview Re-Scheduled", value: 25 },
  { label: "L3 Interview Re-Scheduled", value: 26 },
  { label: "L1 Interview Feedback Pending", value: 27 },
  { label: "L2 Interview Feedback Pending", value: 28 },
  { label: "L3 Interview Feedback Pending", value: 29 },
  { label: "Rejected By Client", value: 30 },
  { label: "Selected but no response from the client", value: 31 },
  { label: "Rejected after Client Selection", value: 32 },
  { label: "Submitted to End Client", value: 33 },
  { label: "Vendor Interview", value: 34 },
  { label: "Vendor Interview Reject", value: 35 },
  { label: "Client Interview", value: 36 },
  { label: "Client Interview Select", value: 37 },
  { label: "Client Interview Reject", value: 38 },
  { label: "Client Interview Completed", value: 39 },
  { label: "End Client Interview", value: 40 },
  { label: "End Client Interview Completed", value: 41 },
  { label: "Selected By Vendor", value: 42 },
  { label: "Selected By Client", value: 43 },
  { label: "Selected By End Client", value: 44 },
  { label: "Rejected By Vendor", value: 45 },
  { label: "Rejected by End Client", value: 46 },
  { label: "Disqualified By Vendor", value: 47 },
  { label: "Disqualified By Client", value: 48 },
  { label: "Disqualified by End Client", value: 49 },
  { label: "Hold By Vendor", value: 50 },
  { label: "Hold By Client", value: 51 },
  { label: "Hold by End Client", value: 52 },
  { label: "Drop", value: 53 },
  { label: "Position on Hold", value: 54 },
  { label: "PW Interview Proposed By Buyer", value: 55 },
  { label: "PW Interview Proposed By Supplier", value: 56 },
  { label: "PW Interview Failed", value: 57 },
  { label: "PW Interview Cancelled", value: 58 },
  { label: "PW Interview Success", value: 59 },
  { label: "Assignment Contract Sent", value: 60 },
  { label: "Assignment Contract Verified", value: 61 },
  { label: "Assignment Contract Rejected", value: 62 },
  { label: "Confirmed", value: 63 },
  { label: "Position Filled", value: 64 },
  { label: "Backout", value: 65 },
  { label: "Not Joined", value: 66 },
  { label: "BGV Failed", value: 67 },
  { label: "Got Pay Rate Confirmation", value: 68 },
  { label: "Offer Withdrawn", value: 69 },
  { label: "Negotiation", value: 70 },
  { label: "Start", value: 71 },
  { label: "Offer Sent", value: 72 },
  { label: "Offer Accepted", value: 73 },
  { label: "Offer Rejected", value: 74 },
  { label: "Hold with Client", value: 75 },
  { label: "Hold with Vendor", value: 76 },
];

const InterviewFollowup = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { followupInterviews } = useSelector((state) => state.bdmJobs);
  const { data, loading } = followupInterviews;
  const { value } = useSelector((state) => state.totalCount);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const totalCount = value?.followUpSubCount?.data || 0;

  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [noteModal, setNotesModal] = useState(false);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [hoveredVisitHistorys, setHoveredVisitHistorys] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  const [selectedRows,setSelectedRows] = useState([])
  // console.log(selectedApplicantId)

  const filterData = followupInterviews?.data.find(
    (data) => String(data?.candidateId?.uiid) === String(selectedApplicantId),
  );

  const handleStatusChange = async (option, row) => {
    try {
      setStatusLoading(true);
      const newStatus = option;

      // build payload to push into statusHistory
      const payload = [
        {
          type: "PUSH",
          value: {
            statusHistory: {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
            },
          },
        },
      ];

      const res = await updateSubmissionStatus({
        coll: "Submission",
        uiid: row?.uiid,
        payload,
      });

      if (res?.data) {
        showToast("Status updated successfully", "success");
        const payload = {
          coll: "Submission",
          lim: 10,
          pg: 1,
          ref: "JobPosting Candidate",
          fil: {
            "statusHistory.status": {
              type: "ARRAY_LAST_TWO_FIELDS_EQ",
              value: [
                12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
                28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
                44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
                60, 61, 62,
              ],
            },
          },
          extret: "uiid firstName",
          ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn companyId",
          incl: [
            "uiid jobInfo.jobCode jobInfo.endClient",
            "uiid firstName lastName jobTitle",
          ],
          sort: { addedOn: -1 },
        };

        dispatch(fetchFollowupInterviewsStart(payload));
      } else {
        showToast("Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    } finally {
      setStatusLoading(false);  
    }
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);

    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: Array.isArray(notes) ? Math.max(notes.length, 1) : 20,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const handleVisitHistory = async (row) => {
    try {
      if (!row?.candidateUiid) return;
      await addVisitHistoryApi({
        coll: "VisitHistory",
        payload: {
          candidateId: row.candidateUiid,
          addedBy: user?.data?.uiid,
        },
      });
    } catch (error) {
      console.error("Error logging visit history:", error);
    }
  };

  const getHoveredVisitHistorys = async (applicantId) => {
    setHoveredVisitHistorys([]);
    try {
      const res = await fetchVisitHistorysApi({
        coll: "VisitHistory",
        fil: {
          candidateId: { type: "NONE", value: applicantId },
        },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
        limit: 5,
      });

      if (res?.data) {
        setHoveredVisitHistorys(res.data.data || []);
      } else {
        setHoveredVisitHistorys([]);
      }
    } catch (error) {
      console.error("Error fetching visit history:", error);
    }
  };

  const columns = [
    {
      key: "icons",
      label: "",
      render: (row) => (
        <div className="flex items-center">
          <div
            onMouseEnter={() => getHoveredVisitHistorys(row?.candidateUiid)}
            onMouseLeave={() => setHoveredVisitHistorys([])}
          >
            <SmartTooltip
              description={
                Array.isArray(hoveredVisitHistorys) &&
                hoveredVisitHistorys?.length > 0 ? (
                  <div className="flex flex-col gap-2">
                    {hoveredVisitHistorys.map((hoveredVisitHistory, i) => (
                      <p key={i}>
                        last visited by{" "}
                        {formatWords2(hoveredVisitHistory?.addedBy?.firstName) ||
                          ""}{" "}
                        on{" "}
                        {dateFormator(
                          convertFromUTC(hoveredVisitHistory?.addedOn),
                          "datetime-ampm",
                        ) || ""}
                      </p>
                    ))}
                  </div>
                ) : (
                  "View Details"
                )
              }
              noicon
              portal={true}
            >
              <Button
                type="icon"
                color="black"
                icon={"visibility"}
                size="sm"
                variant="text"
                onClick={() => {
                  handleVisitHistory(row);
                  setSelectedApplicantId(row?.candidateUiid);
                  setDetailsDrawer(true);
                }}
              />
            </SmartTooltip>
          </div>
          {row?.notes?.length > 0 && (
            <div
              onMouseEnter={() => getHoveredNotes(row?.notes)}
              onMouseLeave={() => setHoveredNotes([])}
            >
              <DualIcon
                size="sm"
                icon="chat"
                badgeIconColor="bg-success"
                onClick={() => {
                  setSelectedApplicantId(row?.candidateUiid);
                  setNotesModal(true);
                }}
                tooltipDescription={
                  Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredNotes.map((hoveredNote, i) => (
                        <p key={i}>
                          "{hoveredNote?.note || ""}" by{" "}
                          {formatWords2(hoveredNote?.addedBy?.firstName) || ""} on{" "}
                          {dateFormator(
                            convertFromUTC(hoveredNote?.addedOn),
                            "datetime-ampm",
                          ) || ""}
                        </p>
                      ))}
                    </div>
                  ) : (
                    "Add note"
                  )
                }
                tooltipDelay={500}
                showTooltip={true}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      key: "candidatename",
      label: "Candidate Name",
      width: "min-w-[230px]! max-w-[280px]!",
      render: (row) => (
        <SmartTooltip
          description={row.candidatename}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.candidatename}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "accountName",
      label: "Account Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.accountName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.accountName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "title",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.title}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.title}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobid",
      label: "Job ID",
      width: "min-w-[230px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobid}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobid}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "createdby",
      label: "Submission Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "createdon",
      label: "Submission Created On",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "status",
      label: "Candidate Status",
      width: "min-w-[220px]! max-w-[250px]!",
      render: (row) => (
        <div className="w-[180px] min-w-[160px]">
          <FormFieldSet
            type="select"
            noTitle
            size="sm"
            // value="scheduled"
            value={
              row?.statusHistory?.[row?.statusHistory?.length - 1]?.status || ""
            }
            options={statusOptions}
            onChange={(option) => handleStatusChange(option, row)}
            showSearch
          />
        </div>
      ),
    },
    // {
    //   key: "dueInDays",
    //   label: "Due in days",
    // },
  ];
  const rows =
    data?.map((item) => ({
      candidatename: `${formatWords2(item?.candidateId?.firstName || "—")} ${formatWords2(item?.candidateId?.lastName || "")}`,
      accountName: formatWords2(item?.jobPostId?.jobInfo?.endClient || item?.jobPostId?.companyId?.name || item?.jobPostId?.jobId?.companyId?.name || "—"),
      title: formatWords2(item?.candidateId?.jobTitle || "—"),
      jobid: item?.jobPostId?.jobInfo?.jobCode || "—",
      createdby: formatWords2(item?.addedBy?.firstName || "—"),
      createdon: dateFormator(convertFromUTC(item?.addedOn), "full"),
      statusHistory: item?.statusHistory || [],
      uiid: item?.uiid || null,
      candidateUiid: item?.candidateId?.uiid,
      notes: item?.candidateId?.notes || [],
    })) || [];
  const mappedRows = mapTableRows(rows, columns);

  useEffect(() => {
    const filters = {
      currentStatus: {
        type: "IN",
        value: [
          12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
          29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
          46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62,
        ],
      },
    };
    if (user?.data?.role?.type !== 1) {
      filters.addedBy = { type: "NONE", value: user?.data?.uiid };
    }
    const payload = {
      coll: "Submission",
      lim: limit,
      pg: page,
      ref: "JobPosting Candidate",
      // fil: {
      //   "statusHistory.status": { type: "ARRAY_LAST_TWO_FIELDS_EQ", value: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62] }
      // },
      fil: filters,
      extret: "uiid firstName",
      ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn",
      incl: [
        "uiid jobInfo.jobCode jobInfo.endClient",
        "uiid firstName lastName jobTitle notes",
      ],
      sort: { addedOn: -1 },
    };
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "followUpSubCount",
        // filters: {
        //   "statusHistory.status": { type: "ARRAY_LAST_TWO_FIELDS_EQ", value: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62] }
        // },
        filters: filters,
        app: "ats",
      }),
    );
    dispatch(fetchFollowupInterviewsStart(payload));
  }, [dispatch, limit, page]);

  return (
    <div className="flex flex-col mt-5 flex-1 overflow-hidden!">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="overflow-hidden flex flex-col">
          <TableAdv
            showCheckbox
            rows={mappedRows}
            columns={columns}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            tableId={"internalFollowUp"}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            onSelectionChange={setSelectedRows}
            defaultSelectedRows={selectedRows}
            tdClassName="!py-3"
            toolbarRight={{
              //search: true,
              filter: true,
              download: false,
              fullScreen: true,
            }}
          />
        </div>
      </div>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
      />
      <AddNoteModal
       key={selectedApplicantId || filterData?.candidateId?.uiid || filterData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={filterData}
      />
      <Backdrop isOpen={loading || statusLoading} zIndex={51}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default InterviewFollowup;
